// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1tugf","log":"ModalInventoryLogs_log__lojsD","date":"ModalInventoryLogs_date__192KW","userName":"ModalInventoryLogs_userName__3LD-K"};